/* Viking Roots cart shipping progress: read only confirmed Shopify cart totals. */
(function (root) {
  'use strict';

  var SEK_THRESHOLD_CENTS = 49900;

  function asMinorUnits(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount) || amount < 0 || Math.floor(amount) !== amount) return null;
    return amount;
  }

  function confirmedShippingState(totalCents, thresholdCents, pending) {
    var threshold = asMinorUnits(thresholdCents);
    var total = asMinorUnits(totalCents);
    if (threshold === null || threshold === 0 || total === null) return null;

    if (pending) {
      return {
        pending: true,
        reached: false,
        percentage: 0,
        remainingCents: null,
        totalCents: total,
        thresholdCents: threshold
      };
    }

    var reached = total >= threshold;
    return {
      pending: false,
      reached: reached,
      percentage: Math.min(100, (total / threshold) * 100),
      remainingCents: Math.max(0, threshold - total),
      totalCents: total,
      thresholdCents: threshold
    };
  }

  function formatSEK(cents) {
    var amount = asMinorUnits(cents);
    if (amount === null) return '';
    try {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK'
      }).format(amount / 100);
    } catch (error) {
      return (amount / 100).toFixed(2).replace('.', ',') + ' kr';
    }
  }

  var api = {
    SEK_THRESHOLD_CENTS: SEK_THRESHOLD_CENTS,
    asMinorUnits: asMinorUnits,
    confirmedShippingState: confirmedShippingState,
    formatSEK: formatSEK
  };

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;

  var document = root.document;

  function isSEKShippingGoal(element) {
    return element &&
      element.dataset.vrShippingGoal === 'true' &&
      element.dataset.vrCurrency === 'SEK';
  }

  function setMessage(element, state) {
    var message = element.querySelector('.cart-progress__text');
    if (!message) return;

    message.textContent = '';
    if (state.pending) {
      message.appendChild(document.createTextNode('Uppdaterar frakt…'));
      return;
    }

    if (state.reached) {
      message.appendChild(document.createTextNode('Du har fri frakt'));
      return;
    }

    var amount = document.createElement('span');
    amount.setAttribute('data-vr-shipping-remaining', '');
    amount.setAttribute('data-vr-amount-cents', String(state.remainingCents));
    amount.textContent = formatSEK(state.remainingCents);

    message.appendChild(document.createTextNode('Handla för '));
    message.appendChild(amount);
    message.appendChild(document.createTextNode(' till – 29 kr frakt under 499 kr'));
  }

  function applyState(element, pending) {
    if (!isSEKShippingGoal(element)) return;

    var total = element.dataset.vrConfirmedTotalCents || element.dataset.cartTotalCents;
    var threshold = element.dataset.vrThresholdCents || SEK_THRESHOLD_CENTS;
    var state = confirmedShippingState(total, threshold, pending);
    if (!state) return;

    var progress = element.querySelector('.cart-progress__bar__progress');
    if (progress) progress.style.width = String(state.percentage) + '%';

    element.dataset.vrShippingState = state.pending ? 'pending' : (state.reached ? 'reached' : 'in-progress');
    if (state.pending) element.setAttribute('aria-busy', 'true');
    else element.removeAttribute('aria-busy');

    setMessage(element, state);
  }

  function syncConfirmed(scope) {
    var container = scope || document;
    var elements = [];
    if (container.matches && container.matches('cart-progress-bar[data-vr-shipping-goal="true"]')) elements.push(container);
    if (container.querySelectorAll) {
      elements = elements.concat(Array.prototype.slice.call(container.querySelectorAll('cart-progress-bar[data-vr-shipping-goal="true"]')));
    }
    elements.forEach(function (element) { applyState(element, false); });
  }

  function markPending() {
    document.querySelectorAll('cart-progress-bar[data-vr-shipping-goal="true"]').forEach(function (element) {
      applyState(element, true);
    });
  }

  function actionChangesCart(target) {
    if (!target || !target.closest) return false;

    if (target.closest('.cart-drawer cart-remove-button, .cart-drawer [data-cart-remove], .cart-drawer .quantity__button')) {
      return true;
    }

    return Boolean(target.closest('.pb-product-form, product-form form, form[action*="/cart/add"]'));
  }

  function isVisibleError(element) {
    if (!element || !element.matches) return false;
    var error = element.matches('[data-pb-cart-status], .cart-drawer .cart-item__error-text')
      ? element
      : element.closest('[data-pb-cart-status], .cart-drawer .cart-item__error-text');
    return Boolean(error && !error.hidden && error.getAttribute('aria-hidden') !== 'true' && error.textContent.trim());
  }

  function observeDrawerUpdates() {
    if (!root.MutationObserver || !document.documentElement) return;

    var observer = new root.MutationObserver(function (records) {
      var shouldSync = false;
      var shouldRestoreConfirmed = false;

      records.forEach(function (record) {
        if (record.type === 'attributes') {
          if (isSEKShippingGoal(record.target)) shouldSync = true;
          if (isVisibleError(record.target)) shouldRestoreConfirmed = true;
          return;
        }

        if (record.type === 'characterData') {
          if (isVisibleError(record.target.parentElement)) shouldRestoreConfirmed = true;
          return;
        }

        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (isSEKShippingGoal(node) || node.querySelector && node.querySelector('cart-progress-bar[data-vr-shipping-goal="true"]')) shouldSync = true;
          if (isVisibleError(node) || node.querySelector && isVisibleError(node.querySelector('[data-pb-cart-status], .cart-drawer .cart-item__error-text'))) shouldRestoreConfirmed = true;
        });
      });

      if (shouldRestoreConfirmed) syncConfirmed();
      else if (shouldSync) syncConfirmed();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-cart-total-cents', 'data-vr-confirmed-total-cents', 'hidden', 'aria-hidden'],
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function init() {
    syncConfirmed();
    observeDrawerUpdates();

    document.addEventListener('click', function (event) {
      if (actionChangesCart(event.target)) markPending();
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('.cart-drawer .quantity__input')) markPending();
    }, true);

    document.addEventListener('submit', function (event) {
      if (actionChangesCart(event.target)) markPending();
    }, true);

    document.addEventListener('petbloom:cart-added', function () {
      root.requestAnimationFrame(function () { syncConfirmed(); });
    });

    document.addEventListener('cart:updated', function () { syncConfirmed(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}(typeof window !== 'undefined' ? window : null));
